import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    departments: [],
    credentials: [],
    allRoles: []
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setDepartments: (state, action) => {
            state.departments = [...action.payload]
        },
        addDepartment: (state, action) => {
            state.departments = [...state.departments, action.payload]
        },
        resetDepartments: state => {
            state.departments = []
        },
        setCredentials: (state, action) => {
            state.credentials = [...action.payload]
        },
        addCredentials: (state, action) => {
            state.credentials = [...state.credentials, action.payload]
        },
        updateCredentials: (state, action) => {
            state.credentials = state.credentials.map(item => {
                if (item.id === action.payload.id) {
                    return action.payload
                }
                return item
            })
        },
        deleteCredential: (state, action) => {
            state.credentials = state.credentials.filter(item => item.id !== action.payload);
        },
        resetCredentials: state => {
            state.credentials = []
        },
        setAllRoles: (state, action) => {
            state.allRoles = [...action?.payload]
        }
    },
});

export const {
    setDepartments,
    addDepartment,
    resetDepartments,
    setCredentials,
    addCredentials,
    resetCredentials,
    updateCredentials,
    setAllRoles,
    deleteCredential,
} = configSlice.actions;
export default configSlice.reducer;